import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {DateTime} from 'luxon';
import ShotChart from './ShotChart.js';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SHOT_COLOR_GENERATORS from './util/SHOT_COLOR_GENERATORS.js';
import combinedShotData from './data/combinedShotData.js';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function InfoPage(props) {
  const params = useParams();
  const threeNumber = Number(params.shotNumber);
  const currentShotData = combinedShotData[threeNumber-1];
  const secondsRemaining = currentShotData.SECONDS_REMAINING;
  let navigate = useNavigate();

  const handleForwardArrowClick = () => {
    if (threeNumber === 2974) {
      navigate('../1');
    } else {
      navigate(`../${threeNumber + 1}`);
    }
  }

  const handleBackArrowClick = () => {
    if (threeNumber === 1) {
      navigate('../2974');
    } else {
      navigate(`../${threeNumber - 1}`);
    }
  }

  return (
    <div className="info-page">
      <div className="shot-number-header">
        <IconButton aria-label="previous shot" onClick={handleBackArrowClick}>
          <ArrowBackIosIcon/>
        </IconButton>
        <h2>#{threeNumber}</h2>
        <IconButton aria-label="next shot" onClick={handleForwardArrowClick}>
          <ArrowForwardIosIcon/>
        </IconButton>
      </div>

      <div>
        {currentShotData.CLIP_URL &&
          (
            <div className="shot-video">
              <iframe
                width="100%"
                height="100%"
                src={currentShotData.CLIP_URL}
                title="Video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen>
              </iframe>
            </div>
          )
        }
        {currentShotData.VIDEO_URL && currentShotData.VIDEO_URL !== 'None' &&
          (
            <div className="shot-video" key={threeNumber}>
              <video controls width="100%">
                <source src={currentShotData.VIDEO_URL + '#t=0.1'} type="video/mp4"/>
              </video>
            </div>
          )
        }
        <ShotChart shots={[currentShotData]} shotColorGenerator={SHOT_COLOR_GENERATORS.GAME_DATE_CY} shouldAnimate="true"/>
        <h3>
          Shot info
        </h3>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">Date</TableCell>
                <TableCell align="right">{DateTime.fromISO(currentShotData['GAME_DATE']).toLocaleString(DateTime.DATE_HUGE)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">Home team</TableCell>
                <TableCell align="right">{currentShotData['HTM']}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">Visiting team</TableCell>
                <TableCell align="right">{currentShotData['VTM']}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">Time</TableCell>
                <TableCell align="right">{currentShotData['MINUTES_REMAINING']}:{secondsRemaining.toString().length === 2? secondsRemaining : '0'+secondsRemaining} remaining in Q{currentShotData['PERIOD']}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">Shot distance</TableCell>
                <TableCell align="right">{currentShotData['SHOT_DISTANCE']} ft</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">Shot zone</TableCell>
                <TableCell align="right">{currentShotData['SHOT_ZONE_BASIC']}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div>
        <h3>
          NFT info
        </h3>
        <div className="nft-image">
          <a href={currentShotData['nftUrl']} target="blank">
            <img src={currentShotData['imageUrl']} width="300" height="300" alt="2974 Collection NFT"/>
          </a>
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">Name</TableCell>
                  <TableCell align="right">{currentShotData['name']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Link to NFT</TableCell>
                  <TableCell align="right">
                    <a href={currentShotData['nftUrl']} target="blank">
                      See it on FTX
                    </a>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">3-Pointers made in the game</TableCell>
                  <TableCell align="right">{currentShotData['3-Pointers made in the game']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Special Moment</TableCell>
                  <TableCell align="right">{currentShotData['Special Moment']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Illustration</TableCell>
                  <TableCell align="right">{currentShotData['Illustration']}</TableCell>
                </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default InfoPage;